import * as types from './types'
import {createAction} from '@reduxjs/toolkit'

export const filter = createAction(
  types.FILTER, (distance) => ({
  payload: {
    distance,
  }
}))

export const filterFail = () => ({
  type: types.FILTER_FAIL,
});

export const filterSuccess = lookupData => ({
  type: types.FILTER_SUCCESS,
  lookupData,
});

export const filterReset = () => ({
  type: types.FILTER_RESET,
});